import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// import { fetchCount } from './counterAPI';

const initialState = {
  showStatus: false,
  videoId: '',
}

export const playerModalSlice = createSlice({
  name: 'playerModal',
  initialState,
  reducers: {
    setShowPlayerModalStatus: (state, action) => {
      state.showStatus = action.payload
    },
    setVideoId: (state, action) => {
      state.videoId = action.payload
    }
  },
})

export const selectShowPlayerModalStatus = (state) => state.playerModal.showStatus
export const selectVideoId = (state) => state.playerModal.videoId

export const { setShowPlayerModalStatus, setVideoId } = playerModalSlice.actions

export default playerModalSlice.reducer
